<template>
  <div>
    <div>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="80px"
        size="mini"
      >
        <el-form-item label="货源单号">
          <el-input v-model="form.mainOrderNumber" :disabled="true" />
        </el-form-item>
        <el-form-item label="货源code" style="display: none">
          <el-input v-model="form.code" :disabled="true" />
        </el-form-item>
        <el-form-item label="托运人报价">
          <el-input v-model="form.price" :disabled="true" />
        </el-form-item>
        <el-form-item label="审核单价" prop="realPrice">
          <el-input
            v-model="form.realPrice"
            @input="
              value =>
                formFormatter.isFloor2(value, oldValue, form, 'realPrice')
            "
          />
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="modbuton()"> 确定 </el-button>
    </div>
  </div>
</template>
<script>
import { ModifyPrice } from "@/api/orderform";
import { validatenumber } from "@/utils/validate.js";

export default {
  data() {
    return {
      form: {
        mainOrderNumber: "",
        price: "",
        orderCode: "",
        realPrice: ""
      },
      emptyForm: {},
      rules: {
        realPrice: [
          {
            required: true,
            validator(rule, value, callback) {
              validatenumber(value)
                ? callback()
                : callback(new Error("请输入调整单价(数字类型)"));
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    modpic(row) {
      this.form = JSON.parse(JSON.stringify(this.emptyForm));
      this.form.mainOrderNumber = row.mainOrderNumber;
      this.form.price = row.price;
      this.form.orderCode = row.code;
      this.form.realPrice = "";
    },
    // modbuton() {
    //     const rLoading = this.openLoading()
    //     ModifyPrice(this.form).then((response) => {
    //         this.$message({ type: 'success', message: response.msg })
    //         rLoading.close()
    //         this.$emit('event1')
    //     })
    // },
    modbuton() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          ModifyPrice(this.form).then(response => {
            this.$message({
              type: "success",
              message: response.msg
            });
            rLoading.close();
            this.$emit("event1");
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin-top: 50px;
}
.titleh1 {
  line-height: 50px;
  border-bottom: 1px solid #e2e2e2;
  margin-bottom: 15px;
  code {
    width: 5px;
    height: 20px;
    background-color: #ff7f21;
    float: left;
    margin-right: 5px;
    margin-top: 13px;
  }
}
</style>
